/// <reference types="react-scripts" />
import { Alert, Box } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import * as frontService from "../../../models/services/frontService";
import { AttachmentIcon } from "../../attachments/AttachmentIcon";
import { CardContainer } from "../../framework/CardContainer";
import { DashboardCardProgress } from "../../framework/DashboardCard/DashboardCardProgress";
import { DashboardCardTitle } from "../../framework/DashboardCard/DashboardCardTitle";
import { List } from "../../framework/List/List";
import { useEffect, useRef, useState } from "react";
import { IFrontFileItem } from "source/models/front/frontFileItem";
import { DownloadToolButton } from "source/components/framework/Button/DownloadToolButton";

interface IFrontDocumentBrowserState {
    // List
    intialized: boolean;
    isLoading: boolean;
    items: IFrontFileItem[];
    selectedId: string;
}

export const FrontDocumentBrowser = () => {
    const _isMounted = useRef(false);
    const [state, setState] = useState<IFrontDocumentBrowserState>({
        intialized: false,
        isLoading: false,
        items: [],
        selectedId: null,
    });

    useEffect(() => {
        const loadDocuments = async () => {
            setState(old => ({ ...old, isLoading: true }));
            const result = await AppUtils.callService(() => frontService.getDocumentBrowserFrontFileItems(), false, true, () => {
                if (!_isMounted.current) return;
                setState(old => ({ ...old, isLoading: false }));
            });
            const items = List.getListItems(state.items, state.selectedId, [], result.items, true, false);
            setState(old => ({
                ...old,
                intialized: true,
                items: items.items,
                selectedId: items.selectedId,
                checkedIds: items.checkedIds,
            }));
        };

        _isMounted.current = true;
        loadDocuments();

        return () => {
            _isMounted.current = false;
        };
    }, []);

    const handleSetSelectedIds = (selectedId: string, _checkedIds: string[]) => {
        setState(old => ({ ...old, selectedId }));
    };

    const handleDownloadFile = async (id: string) => {
        if (!id) return;
        const fileName = AppUtils.callService(() => frontService.downloadDocumentBrowserDocument(id));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.FileParameterDownloaded, fileName));
    };

    return (
        <>
            <>
                <DashboardCardTitle
                    title={Translations.FrontPageDocuments}
                />
            </>
            <CardContainer>
                <DashboardCardProgress isLoading={state.isLoading} />
                {!state.isLoading && state.items.length < 1 &&
                    <Alert severity="info">{Translations.NoDataToShow}</Alert>
                }
                {state.items.length > 0 &&
                    <List
                        intialized={state.intialized}
                        isLoading={state.isLoading}
                        hasMore={false}
                        header={null}
                        lines={state.items.map((item) => {
                            return {
                                columns: [
                                    {
                                        size: 12,
                                        content: <Box
                                            display="flex"
                                            alignItems="center"
                                            overflow="hidden"
                                            width="100%"
                                        >
                                            <Box><AttachmentIcon fileType={item.fileType} color="#E9F0FA" strokeColor="#848688" /></Box>
                                            <Box sx={{ marginLeft: "4px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.code}</Box>
                                            <Box sx={{ marginLeft: "auto" }}><DownloadToolButton onClick={() => handleDownloadFile(item.id)} /></Box>
                                        </Box>
                                    }
                                ],
                                id: item.id,
                            };
                        })}
                        cards={null}
                        sortColumn={""}
                        sortOrderIsAsc={true}
                        selectedId={state.selectedId}
                        checkedIds={[]}
                        onSetSelectedIds={handleSetSelectedIds}
                        onSearchLines={() => {}}
                        onOpenLine={handleDownloadFile}
                    />
                }
            </CardContainer>
        </>
    );
};